export default __webpack_public_path__ + "images/Microsoft_logo.png";